export const ACTIONS = {
  addBreadCrumb: 'ADD_BREAD_CRUMB',
  removeAdjacentBreadCrumbs: 'REMOVE_ADJACENT_BREAD_CRUMBS',
  removeAllBreadCrumbs: 'REMOVE_ALL_BREAD_CRUMBS',
  updateResultsOverviewRoute: 'UPDATE_RESULTS_OVERVIEW_ROUTE',
  updateSingleBreadcrumb: 'UPDATE_SINGLE_BREAD_CRUMB',
  updatePreviousPageRoute: 'UPDATE_PREVIOUS_ROUTE_PAGE',
};
